/** @format */
import { Directive, TemplateRef } from '@angular/core';

/**
 * A marker directive used to tag the custom title template rendered in the `ExpandableComponent` header.
 */
@Directive({
    selector: '[sisExpandableCustomTitle]',
    standalone: false,
})
export class ExpandableCustomTitleDirective {
    constructor(public templateRef: TemplateRef<unknown>) {}
}
